import React from 'react';
import { useBookingContext } from '../context';
import { isTimeBetweenRange, areTimeRangesCollided } from '../utils';
import moment from 'moment';

export default ({ booking, courtDetails }) => {
  const { setTime, startTime, endTime, resetTime, setCourt, court, selectedDate } = useBookingContext();

  const borderColor = booking.price === 200 ? 'border-lower-price' : 'border-higher-price';
  const selectedBorder =
      court?.courtId === courtDetails._id &&
      (booking.time === startTime || booking.time === endTime ? 'border-selected' : '');
  const middleBoder =
      court?.courtId === courtDetails._id &&
      isTimeBetweenRange(booking.time, startTime, endTime, '()')
          ? 'middle-selected-border'
          : '';

  const isToday = moment().isSame(moment(selectedDate), 'day')
  const isInThePast = moment(booking.time).isBefore(moment()
      .tz('Europe/Kyiv').format('HH:mm'), 'minute');

  return (
      <div
          className={`${borderColor} booking-button court__item js-court__item o-btn o-btn__fourth o-btn-rewright-width ${
              !booking.isFree || (isInThePast && isToday) ? 'disabled' : ''
          } ${selectedBorder} ${middleBoder} ${
              court?.courtId === courtDetails._id && booking.time === startTime && !!endTime
                  ? 'start-border'
                  : ''
          } ${court?.courtId === courtDetails._id && booking.time === endTime ? 'end-border' : ''}`}
          onClick={() => {
            if (!booking.isFree || isInThePast) return;

            setCourt({
              courtName: courtDetails.name,
              courtId: courtDetails._id
            });

            if (startTime && courtDetails._id !== court?.courtId) return resetTime();

            if (booking.time === startTime && !endTime) {
              resetTime();
            }

            if ((!startTime || !endTime) && (booking.time < startTime || booking.time > endTime)) return;

            if (startTime && !endTime) {
              if (moment(booking.time, 'HH:mm').diff(moment(startTime, 'HH:mm'), 'hours') < 1) return;

              const isCollided = courtDetails.bookings.some((b) => {
                return areTimeRangesCollided(startTime, booking.time, b.startTime, b.endTime);
              });

              if (isCollided) return;
            }

            setTime(booking.time);
          }}>
        <span className="court__time">{booking.time}</span>
      </div>
  );
};
